export const keys = [
  {
    key: "0x00",
    desc: "mouseLeftClick",
  },
  {
    key: "0x02",
    desc: "mouseWheelClick",
  },
  {
    key: "0x01",
    desc: "mouseRightClick",
  },
  {
    key: "0x0e",
    desc: "mouseWheelUp",
  },
  {
    key: "0x0f",
    desc: "mouseWheelDown",
  },
  {
    key: "0x03",
    desc: "mouseForward",
  },
  {
    key: "0x04",
    desc: "mouseBackward",
  },
];

export const mouseKeys = [
  {
    key: ["0x01", "0x00", "0xf0", "0x00"],
    desc: "mouseLeftClick",
  },
  {
    key: ["0x01", "0x00", "0xf1", "0x00"],
    desc: "mouseRightClick",
  },
  {
    key: ["0x01", "0x00", "0xf5", "0x01"],
    desc: "mouseWheelUp",
  },
  {
    key: ["0x01", "0x00", "0xf5", "0xff"],
    desc: "mouseWheelDown",
  },
  {
    key: ["0x01", "0x00", "0xf2", "0x00"],
    desc: "mouseWheelClick",
  },
  {
    key: ["0x01", "0x00", "0xf4", "0x00"],
    desc: "mouseForward",
  },
  {
    key: ["0x01", "0x00", "0xf3", "0x00"],
    desc: "mouseBackward",
  },
];

export const basicKeys = [
  {
    key: ["0x14", "0x00", "0x01", "0x00"],
    desc: "dpiPlus",
  },
  {
    key: ["0x14", "0x00", "0x02", "0x00"],
    desc: "dpiMinus",
  },
  {
    key: ["0x14", "0x00", "0x00", "0x00"],
    desc: "dpiToggle",
  },
  {
    key: ["0x08", "0x00", "0x01", "0x00"],
    desc: "profilePlus",
  },
  {
    key: ["0x08", "0x00", "0x02", "0x00"],
    desc: "profileMinus",
  },
  {
    key: ["0x08", "0x00", "0x03", "0x00"],
    desc: "profileToggle",
  },
  {
    key: ["0x03", "0x00", "0x83", "0x01"],
    desc: "mediaPlayer",
  },
  {
    key: ["0x03", "0x00", "0xcd", "0x00"],
    desc: "playPause",
  },
  {
    key: ["0x03", "0x00", "0xb7", "0x00"],
    desc: "stop",
  },
  {
    key: ["0x03", "0x00", "0xb6", "0x00"],
    desc: "previousTrack",
  },
  {
    key: ["0x03", "0x00", "0xb5", "0x00"],
    desc: "nextTrack",
  },
  {
    key: ["0x03", "0x00", "0xe9", "0x00"],
    desc: "volumePlus",
  },
  {
    key: ["0x03", "0x00", "0xea", "0x00"],
    desc: "volumeMinus",
  },
  {
    key: ["0x03", "0x00", "0xe2", "0x00"],
    desc: "mute",
  },
  {
    key: ["0x03", "0x00", "0x92", "0x01"],
    desc: "calculator",
  },
  {
    key: ["0x03", "0x00", "0x8a", "0x01"],
    desc: "email",
  },
  {
    key: ["0x03", "0x00", "0x94", "0x01"],
    desc: "myComputer",
  },
  {
    key: ["0x03", "0x00", "0x21", "0x02"],
    desc: "search",
  },
  {
    key: ["0x03", "0x00", "0x23", "0x02"],
    desc: "home",
  },
  {
    key: ["0x03", "0x00", "0x6f", "0x00"],
    desc: "brightnessPlus",
  },
  {
    key: ["0x03", "0x00", "0x70", "0x00"],
    desc: "brightnessMinus",
  },
  {
    key: ["0x03", "0x00", "0x27", "0x02"],
    desc: "refresh",
  },
  {
    key: ["0x00", "0x00", "0xe3", "0x2d"],
    desc: "zoomOut",
  },
  {
    key: ["0x00", "0x00", "0xe3", "0x2e"],
    desc: "zoomIn",
  },
  // {
  //   key: ["0x06", "0x80", "0x00", "0x00"],
  //   desc: "microphoneToggle",
  // },
  // {
  //   key: ["0x08", "0x00", "0x01", "0x00"],
  //   desc: "layerPlus",
  // },
  // {
  //   key: ["0x08", "0x00", "0x02", "0x00"],
  //   desc: "layerMinus",
  // },
  // {
  //   key: ["0x08", "0x00", "0x03", "0x00"],
  //   desc: "layerToggle",
  // },
];

export const allKeys = [...mouseKeys, ...basicKeys];

export const codeKeys = {
  "↓MouseLeft": "0x00f0",
  "↑MouseLeft": "0xf000",
  "↓MouseRight": "0x00f1",
  "↑MouseRight": "0xf100",
  "↓MouseWheel": "0x00f2",
  "↑MouseWheel": "0xf200",
  "↓MouseBack": "0x00f3",
  "↑MouseBack": "0xf300",
  "↓MouseForward": "0x00f4",
  "↑MouseForward": "0xf400",

  "↓KeyA": "0x1104",
  "↑KeyA": "0x1004",
  "↓KeyB": "0x1105",
  "↑KeyB": "0x1005",
  "↓KeyC": "0x1106",
  "↑KeyC": "0x1006",
  "↓KeyD": "0x1107",
  "↑KeyD": "0x1007",
  "↓KeyE": "0x1108",
  "↑KeyE": "0x1008",
  "↓KeyF": "0x1109",
  "↑KeyF": "0x1009",
  "↓KeyG": "0x110a",
  "↑KeyG": "0x100a",
  "↓KeyH": "0x110b",
  "↑KeyH": "0x100b",
  "↓KeyI": "0x110c",
  "↑KeyI": "0x100c",
  "↓KeyJ": "0x110d",
  "↑KeyJ": "0x100d",
  "↓KeyK": "0x110e",
  "↑KeyK": "0x100e",
  "↓KeyL": "0x110f",
  "↑KeyL": "0x100f",
  "↓KeyM": "0x1110",
  "↑KeyM": "0x1010",
  "↓KeyN": "0x1111",
  "↑KeyN": "0x1011",
  "↓KeyO": "0x1112",
  "↑KeyO": "0x1012",
  "↓KeyP": "0x1113",
  "↑KeyP": "0x1013",
  "↓KeyQ": "0x1114",
  "↑KeyQ": "0x1014",
  "↓KeyR": "0x1115",
  "↑KeyR": "0x1015",
  "↓KeyS": "0x1116",
  "↑KeyS": "0x1016",
  "↓KeyT": "0x1117",
  "↑KeyT": "0x1017",
  "↓KeyU": "0x1118",
  "↑KeyU": "0x1018",
  "↓KeyV": "0x1119",
  "↑KeyV": "0x1019",
  "↓KeyW": "0x111a",
  "↑KeyW": "0x101a",
  "↓KeyX": "0x111b",
  "↑KeyX": "0x101b",
  "↓KeyY": "0x111c",
  "↑KeyY": "0x101c",
  "↓KeyZ": "0x111d",
  "↑KeyZ": "0x101d",
  "↓Digit1": "0x111e",
  "↑Digit1": "0x101e",
  "↓Digit2": "0x111f",
  "↑Digit2": "0x101f",
  "↓Digit3": "0x1120",
  "↑Digit3": "0x1020",
  "↓Digit4": "0x1121",
  "↑Digit4": "0x1021",
  "↓Digit5": "0x1122",
  "↑Digit5": "0x1022",
  "↓Digit6": "0x1123",
  "↑Digit6": "0x1023",
  "↓Digit7": "0x1124",
  "↑Digit7": "0x1024",
  "↓Digit8": "0x1125",
  "↑Digit8": "0x1025",
  "↓Digit9": "0x1126",
  "↑Digit9": "0x1026",
  "↓Digit0": "0x1127",
  "↑Digit0": "0x1027",
  "↓Enter": "0x1128",
  "↑Enter": "0x1028",
  "↓Escape": "0x1129",
  "↑Escape": "0x1029",
  "↓Backspace": "0x112a",
  "↑Backspace": "0x102a",
  "↓Tab": "0x112b",
  "↑Tab": "0x102b",
  "↓Space": "0x112c",
  "↑Space": "0x102c",
  "↓Minus": "0x112d",
  "↑Minus": "0x102d",
  "↓Equal": "0x112e",
  "↑Equal": "0x102e",
  "↓BracketLeft": "0x112f",
  "↑BracketLeft": "0x102f",
  "↓BracketRight": "0x1130",
  "↑BracketRight": "0x1030",
  "↓Backslash": "0x1131",
  "↑Backslash": "0x1031",
  "↓Semicolon": "0x1133",
  "↑Semicolon": "0x1033",
  "↓Quote": "0x1134",
  "↑Quote": "0x1034",
  "↓Backquote": "0x1135",
  "↑Backquote": "0x1035",
  "↓Comma": "0x1136",
  "↑Comma": "0x1036",
  "↓Period": "0x1137",
  "↑Period": "0x1037",
  "↓Slash": "0x1138",
  "↑Slash": "0x1038",
  "↓CapsLock": "0x1139",
  "↑CapsLock": "0x1039",
  "↓F1": "0x113a",
  "↑F1": "0x103a",
  "↓F2": "0x113b",
  "↑F2": "0x103b",
  "↓F3": "0x113c",
  "↑F3": "0x103c",
  "↓F4": "0x113d",
  "↑F4": "0x103d",
  "↓F5": "0x113e",
  "↑F5": "0x103e",
  "↓F6": "0x113f",
  "↑F6": "0x103f",
  "↓F7": "0x1140",
  "↑F7": "0x1040",
  "↓F8": "0x1141",
  "↑F8": "0x1041",
  "↓F9": "0x1142",
  "↑F9": "0x1042",
  "↓F10": "0x1143",
  "↑F10": "0x1043",
  "↓F11": "0x1144",
  "↑F11": "0x1044",
  "↓F12": "0x1145",
  "↑F12": "0x1045",
  "↓PrintScreen": "0x1146",
  "↑PrintScreen": "0x1046",
  "↓ScrollLock": "0x1147",
  "↑ScrollLock": "0x1047",
  "↓Pause": "0x1148",
  "↑Pause": "0x1048",
  "↓Insert": "0x1149",
  "↑Insert": "0x1049",
  "↓Home": "0x114a",
  "↑Home": "0x104a",
  "↓PageUp": "0x114b",
  "↑PageUp": "0x104b",
  "↓Delete": "0x114c",
  "↑Delete": "0x104c",
  "↓End": "0x114d",
  "↑End": "0x104d",
  "↓PageDown": "0x114e",
  "↑PageDown": "0x104e",
  "↓ArrowRight": "0x114f",
  "↑ArrowRight": "0x104f",
  "↓ArrowLeft": "0x1150",
  "↑ArrowLeft": "0x1050",
  "↓ArrowDown": "0x1151",
  "↑ArrowDown": "0x1051",
  "↓ArrowUp": "0x1152",
  "↑ArrowUp": "0x1052",
  "↓NumLock": "0x1153",
  "↑NumLock": "0x1053",
  "↓NumpadDivide": "0x1154",
  "↑NumpadDivide": "0x1054",
  "↓NumpadMultiply": "0x1155",
  "↑NumpadMultiply": "0x1055",
  "↓NumpadSubtract": "0x1156",
  "↑NumpadSubtract": "0x1056",
  "↓NumpadAdd": "0x1157",
  "↑NumpadAdd": "0x1057",
  "↓NumpadEnter": "0x1158",
  "↑NumpadEnter": "0x1058",
  "↓Numpad1": "0x1159",
  "↑Numpad1": "0x1059",
  "↓Numpad2": "0x115a",
  "↑Numpad2": "0x105a",
  "↓Numpad3": "0x115b",
  "↑Numpad3": "0x105b",
  "↓Numpad4": "0x115c",
  "↑Numpad4": "0x105c",
  "↓Numpad5": "0x115d",
  "↑Numpad5": "0x105d",
  "↓Numpad6": "0x115e",
  "↑Numpad6": "0x105e",
  "↓Numpad7": "0x115f",
  "↑Numpad7": "0x105f",
  "↓Numpad8": "0x1160",
  "↑Numpad8": "0x1060",
  "↓Numpad9": "0x1161",
  "↑Numpad9": "0x1061",
  "↓Numpad0": "0x1162",
  "↑Numpad0": "0x1062",
  "↓NumpadDecimal": "0x1163",
  "↑NumpadDecimal": "0x1063",
  "↓Menu": "0x1165",
  "↑Menu": "0x1065",
  "↓ControlLeft": "0x11e0",
  "↑ControlLeft": "0x10e0",
  "↓ShiftLeft": "0x11e1",
  "↑ShiftLeft": "0x10e1",
  "↓AltLeft": "0x11e2",
  "↑AltLeft": "0x10e2",
  "↓MetaLeft": "0x11e3",
  "↑MetaLeft": "0x10e3",
  "↓ControlRight": "0x11e4",
  "↑ControlRight": "0x10e4",
  "↓ShiftRight": "0x11e5",
  "↑ShiftRight": "0x10e5",
  "↓AltRight": "0x11e6",
  "↑AltRight": "0x10e6",
  "↓MetaRight": "0x11e7",
  "↑MetaRight": "0x10e7",
};
